module.exports = __webpack_public_path__ + "img/mitt-fagkart-logo.8a18ffc5.png";